import { Button, withStyles } from '@material-ui/core';
import React from 'react';

import { LiveLogsIcon } from '~/src/dash/components/icons/live-logs-icon';
import { smallRadius } from '~/src/dash/utils/material-dashboard-react';

interface IProps {
  onClick: () => void;
  buttonText?: string;
  backgroundColor?: string;
  textColor?: string;

  // is the button position fixed on the bottom right?
  isFixedButton?: boolean; // default = true
}

function getPositionStyle(isFixed: boolean | undefined): React.CSSProperties {
  if (isFixed || isFixed === undefined) {
    return {
      top: 'auto',
      right: 20,
      bottom: 20,
      left: 'auto',
      position: 'fixed',
    };
  }
  return {};
}

function getTextColor(color: string) {
  return { color };
}

function getBackgroundColor(backgroundColor: string) {
  return { backgroundColor };
}

// Button which show the `Open Live Logs`
export const LiveLogsButtonV3 = withStyles({
  root: {
    borderRadius: smallRadius,
  },
})(function (props: IProps) {
  const { textColor, backgroundColor, buttonText, isFixedButton, onClick } = props;
  return (
    <Button
      style={{
        margin: 0,
        ...getPositionStyle(isFixedButton),
        ...getTextColor(textColor || ''),
        ...getBackgroundColor(backgroundColor || ''),
        width: 'auto',
      }}
      onClick={() => onClick()}
    >
      <div
        style={{ marginRight: 10, display: 'flex', justifyContent: 'center', alignItems: 'center' }}
      >
        <LiveLogsIcon fill={textColor ? textColor : 'primary'} width={'18'} height={'20'} />
      </div>
      {buttonText ? buttonText : 'Open Logs'}
    </Button>
  );
});
